import axios from '@axios';
import HelperService from '@/services/HelperService';

const base = 'api/v1/bans';
const helperService = new HelperService();

export default {
  getBansPaginated(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}/paginated${queryString}`);
  },
};
